import { useEffect, useState } from 'react';
import HowItWorks from './components/HowItWorks/HowItWorks';
import MembershipPlans from './components/MembershipPlans/MembershipPlans';
import ReferralProgram from './components/ReferralProgram/ReferralProgram';
import CallToAction from './components/CallToAction/CallToAction';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import css from './LandingPage.module.css';
import loadable from '@loadable/component';
import FAQ from './components/Faq/Faq';
import TermsAndConditions from './components/TermsAndConditions/TermsAndConditions';
import { useLocation } from 'react-router-dom';
import AboutUs from './components/AboutUs/AboutUs';
import PrivacyPolicy from './components/Privacy/PrivacyPolicy';
import { fetchReviews } from '../TransactionPage/TransactionPage.duck';
import { bool, object } from 'prop-types';
import { propTypes } from '../../util/types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { camelize } from '../../util/string';
import { ASSET_NAME } from './LandingPage.duck';

const HeroSection = loadable(() => import('./components/HeroSection/HeroSection'), {
  ssr: false,
});

const Testimonials = loadable(() => import('./components/Testimonials/Testimonials'), {
  ssr: false,
});

const DesignerCollection = loadable(
  () => import('./components/DesignerCollection/DesignerCollection'),
  {
    ssr: false,
  }
);

function LandingPageComponent(props) {
  const [reviews, setReviews] = useState('');
  const [faqData, setFaqData] = useState();

  const location = useLocation();

  const listingIds = props?.pageAssetsData?.[camelize(ASSET_NAME)]?.data?.sections?.find(
    data => data.sectionId === 'designer-collections'
  );
  const faqDataSec = props?.pageAssetsData?.[camelize(ASSET_NAME)]?.data?.sections?.find(
    data => data.sectionId === 'faq-id'
  );

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  const fetchReviewData = async () => {
    let idsContent = listingIds?.description?.content;

    let ids = [];
    if (idsContent && idsContent !== 'undefined') {
      try {
        ids = JSON.parse(idsContent);
      } catch (err) {
        console.error('Invalid JSON in listingIds description content:', idsContent);
      }
    }

    const review = await fetchReviews({ ids });
    setReviews(review);
  };

  useEffect(() => {
    fetchReviewData();

    if (faqDataSec?.description?.content && faqDataSec?.description?.content !== 'undefined') {
      try {
        setFaqData(JSON.parse(faqDataSec.description.content));
      } catch (err) {
        console.error('Invalid JSON in FAQ content:', faqDataSec.description.content);
      }
    }
  }, []);
  return (
    <Page title={'LandingPage'} scrollingDisabled={false}>
      <LayoutSingleColumn
        topbar={
          <>
            <TopbarContainer
              desktopClassName={css.desktopTopbar}
              mobileClassName={css.mobileTopbar}
            />
          </>
        }
        sideNav={null}
        useAccountSettingsNav
        currentPage="LandingPage"
        footer={<FooterContainer />}
      >
        <div className={css.content}>
          <HeroSection />
          <DesignerCollection reviews={reviews} />
          {/* <CallToAction /> */}
          <Testimonials reviews={reviews} />
          <HowItWorks />
          {/* <MembershipPlans /> */}
          {faqData && <FAQ faqData={faqData} />}
          <ReferralProgram />
          <TermsAndConditions />
          {/* <AboutUs />
          <PrivacyPolicy /> */}
        </div>
      </LayoutSingleColumn>
    </Page>
  );
}
LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

const LandingPage = compose(connect(mapStateToProps))(LandingPageComponent);

export default LandingPage;
